export const environment = {
  production: true,
  globalInitURL: 'https://1move.1pay.in/svclocator/globalinit',
  appVersion: 'v0.1.10',
  packageId: 'in.mobile1pay.fleet.uat',
  appBuildDate: '3 Feb 2022',
  appBuildCommitId: '',
  appDbNew: 'New app with version v0.1.10 is released on 3 Feb 2022',
  loggingTool: 'sentry',
  mloggerSeverity: 0,
  sentryDsn: 'https://bf6e9224ad1a4d81a9a4b93bfa1c461b@o1050731.ingest.sentry.io/6033322',
  sentryTracingOrigins: 'https://sentry.io/auth/login/1pay-mobileware-pvt-ltd/',
  firebaseConfig: {
    apiKey: "AIzaSyBKc4unUh-EulSJzrzbxbbeSrFijGlYqOo",
    authDomain: "pay-fastag-uat.firebaseapp.com",
    projectId: "pay-fastag-uat",
    storageBucket: "pay-fastag-uat.appspot.com",
    messagingSenderId: "932108809413",
    appId: "1:932108809413:web:05a35f2ffc345ba9bfecac",
    measurementId: "G-8VW0Y9N266"
  },
  collectionName: 'fleet_users',
  sentryFeedbackUserDialog: false
};
